/**
 * @module hooks/dva/useResultSelectorDva
 * @description DVA 版 useResultSelector — 从 DVA store 读取 result 数据（chartData / saveColumnInfos 等）
 *
 * 签名与 V2 useResultSelector 完全一致：(selector, equalityFn?) => T
 *
 * @see docs/DVA环境迁移执行计划.md §N2
 */

import { shallowEqual, useSelector } from 'umi';
import { CHART_OLD_NAMESPACE } from '@/pages/datalab/models/namespaces';
import type {
  IMultidimensionalAnalysisState,
  IOldAnalysisModelState,
} from '@/pages/datalab/models/types/state';

/**
 * DVA 版 useResultSelector
 *
 * @param selector - 从 model state 中选择需要的值
 * @param equalityFn - 默认 shallowEqual；需引用级比较时显式传 Object.is
 */
export function useResultSelector<T>(
  selector: (state: IOldAnalysisModelState) => T,
  equalityFn: (left: T, right: T) => boolean = shallowEqual,
): T {
  return useSelector(
    (rootState: IMultidimensionalAnalysisState) => {
      const modelState = rootState[CHART_OLD_NAMESPACE];
      return selector(modelState ?? ({} as IOldAnalysisModelState));
    },
    equalityFn,
  );
}

export { shallowEqual as resultSelectorShallowEqual };
